import React, { useState, useEffect } from 'react';
import logo from '../assets/logo.jpg';
import { supabase } from '../lib/supabaseClient';

const allNavItems = [
  { label:'Home',         href:'#home',         key:null },
  { label:'About',        href:'#about',         key:'about' },
  { label:'Pastors',      href:'#pastors',       key:'pastors' },
  { label:'Services',     href:'#services',      key:'services' },
  { label:'Events',       href:'#events',        key:'events' },
  { label:'Sermons',      href:'#sermons',       key:'sermons' },
  { label:'Gallery',      href:'#gallery',       key:'gallery' },
  { label:'Testimonials', href:'#testimonials',  key:'testimonials' },
  { label:'Branches',     href:'#branches',      key:'branches' },
  { label:'Prayer',       href:'#prayer',        key:'prayer' },
  { label:'Give',         href:'#give',          key:'give' },
  { label:'Connect',      href:'#connect',       key:'connect' },
];

const styles = {
  nav: {
    position:'fixed', top:0, width:'100%', zIndex:1000,
    background:'rgba(7,15,34,0.97)',
    backdropFilter:'blur(14px)',
    borderBottom:'1px solid rgba(201,168,76,0.25)',
    padding:'10px 24px',
    display:'flex', alignItems:'center', justifyContent:'space-between',
    gap:12,
  },
  logoWrap: { display:'flex', alignItems:'center', gap:12, textDecoration:'none' },
  logoImg: {
    width:52, height:52, objectFit:'contain',
    mixBlendMode:'screen',   // removes black background on dark navbars
    background:'transparent',
  },
  logoText: {
    color:'var(--primary)',
    fontSize:'0.62rem', fontWeight:600,
    letterSpacing:'0.08em', textTransform:'uppercase',
    lineHeight:1.5,
    fontFamily:"'Raleway',sans-serif",
  },
  links: { display:'flex', flexWrap:'wrap', gap:2, justifyContent:'flex-end' },
  link: {
    color:'var(--text-muted)', textDecoration:'none',
    fontSize:'0.68rem', fontWeight:600,
    letterSpacing:'0.08em', textTransform:'uppercase',
    padding:'6px 10px', borderRadius:5,
    transition:'color 0.25s, background 0.25s',
  },
  mobileMenu: {
    position:'absolute', top:68, left:0, right:0,
    background:'rgba(7,15,34,0.99)',
    borderTop:'1px solid rgba(201,168,76,0.2)',
    padding:'12px 20px',
    display:'flex', flexDirection:'column', gap:4,
  },
};

export default function Navbar() {
  const [open, setOpen] = useState(false);
  const [isMobile, setIsMobile] = useState(window.innerWidth < 820);
  const [vis, setVis] = useState({});

  useEffect(() => {
    const onResize = () => setIsMobile(window.innerWidth < 820);
    window.addEventListener('resize', onResize);
    return () => window.removeEventListener('resize', onResize);
  }, []);

  // Fetch section visibility
  useEffect(() => {
    supabase.from('section_visibility').select('key,enabled')
      .then(({ data }) => {
        if (data) { const m={}; data.forEach(r=>{m[r.key]=r.enabled;}); setVis(m); }
      }).catch(()=>{});
  }, []);

  const show = (key) => key === null ? true : (vis[key]===undefined ? true : Boolean(vis[key]));
  const navItems = allNavItems.filter(item => show(item.key));

  const NavLinks = ({ onClick }) =>
    navItems.map(item => (
      <a key={item.href} href={item.href} style={styles.link} onClick={onClick}
        onMouseEnter={e=>{ e.target.style.color='var(--primary)'; e.target.style.background='rgba(201,168,76,0.1)'; }}
        onMouseLeave={e=>{ e.target.style.color='var(--text-muted)'; e.target.style.background='transparent'; }}
      >
        {item.label}
      </a>
    ));

  return (
    <nav style={styles.nav}>
      <a href="#home" style={styles.logoWrap}>
        <img src={logo} alt="Zion AG" style={styles.logoImg} />
        <div style={styles.logoText}>ZION ASSEMBLIES<br />OF GOD CHURCH — OOTY</div>
      </a>

      {!isMobile && (
        <div style={styles.links}><NavLinks /></div>
      )}

      {isMobile && (
        <button style={{ background:'none', border:'none', color:'var(--primary)', fontSize:'1.5rem', cursor:'pointer' }}
          onClick={() => setOpen(o => !o)}>
          {open ? '✕' : '☰'}
        </button>
      )}

      {isMobile && open && (
        <div style={styles.mobileMenu}>
          <NavLinks onClick={() => setOpen(false)} />
        </div>
      )}
    </nav>
  );
}
